import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import {
  AdapterOptions,
  FlatAnswerMutation,
  SectionAdapter
} from 'components/Assessments/adapters/types'
import { SocFormData } from 'components/Assessments/SocAssessment/types/SocFormData'
import { BaseSubsectionAdapter } from 'components/Assessments/adapters/BaseSubsectionAdapter'
import { BackgroundAdapter } from './subsections/background/adapter'
import { TherapiesAdapter } from './subsections/therapies/adapter'
import { HistoryAdapter } from './subsections/history/adapter'
import { ImmunizationsAdapter } from './subsections/immunizations/adapter'
import { RiskAssessmentAdapter } from './subsections/risk-assessment/adapter'
import { NeurologicalAdapter } from './subsections/neurological/adapter'
import { CognitivePsychosocialAdapter } from './subsections/cognitive-psychosocial/adapter'
import { MusculoskeletalAdapter } from './subsections/musculoskeletal/adapter'
import { LinesDrainsAdapter } from './subsections/lines-drains/adapter'
import { SensoryAdapter } from './subsections/sensory/adapter'
import { PainAdapter } from './subsections/pain/adapter'
import { CardiacAdapter } from './subsections/cardiac/adapter'
import { RespiratoryAdapter } from './subsections/respiratory/adapter'
import { EndocrineAdapter } from './subsections/endocrine/adapter'
import { GastrointestinalAdapter } from './subsections/gastrointestinal/adapter'
import { IntegumentaryAdapter } from './subsections/integumentary/adapter'
import { PhysicianNotificationAdapter } from './subsections/physician-notification/adapter'
import { CareCoordinationAdapter } from './subsections/care-coordination/adapter'
import { VitalsAdapter } from './subsections/vitals/adapter'

/**
 * Array of all medical background subsection adapter instances
 */
const MEDICAL_BACKGROUND_SUBSECTION_ADAPTERS: SectionAdapter<SocFormData>[] = [
  new BackgroundAdapter(),
  new TherapiesAdapter(),
  new HistoryAdapter(),
  new ImmunizationsAdapter(),
  new RiskAssessmentAdapter(),
  new NeurologicalAdapter(),
  new CognitivePsychosocialAdapter(),
  new MusculoskeletalAdapter(),
  new LinesDrainsAdapter(),
  new SensoryAdapter(),
  new PainAdapter(),
  new CardiacAdapter(),
  new RespiratoryAdapter(),
  new EndocrineAdapter(),
  new GastrointestinalAdapter(),
  new IntegumentaryAdapter(),
  new PhysicianNotificationAdapter(),
  new VitalsAdapter(),
  new CareCoordinationAdapter()
]

/**
 * Medical Background section adapter
 * Aggregates all medical background subsections
 */
export class MedicalBackgroundAdapter extends SectionAdapter<SocFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    options?: AdapterOptions
  ): Partial<SocFormData> {
    const formData: Partial<SocFormData> = {}

    // Extract data from all subsection adapters
    for (const adapter of MEDICAL_BACKGROUND_SUBSECTION_ADAPTERS) {
      const subsectionData = adapter.extractFormData(flatAnswers, options)
      Object.assign(formData, subsectionData)
    }

    return formData
  }

  buildFlatAnswers(formData: SocFormData): FlatAnswerMutation[] {
    const allMutations: FlatAnswerMutation[] = []

    // Build mutations from all subsection adapters
    for (const adapter of MEDICAL_BACKGROUND_SUBSECTION_ADAPTERS) {
      if (adapter instanceof BaseSubsectionAdapter) {
        adapter.setFormData(formData)
        allMutations.push(...adapter.buildFlatAnswers())
      } else {
        allMutations.push(...adapter.buildFlatAnswers(formData))
      }
    }

    return allMutations
  }
}
